import type {
  AtualizarConfiguracaoRateioDto,
  ConfiguracaoRateioResponse,
  CriarConfiguracaoRateioDto,
  DestinosConfiguracaoResponse,
  ReordenarConfiguracoesDto,
} from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

/** Configuracoes de rateio (GET /configuracoes-rateio): `rateio.ver`; alteracoes: `rateio.editar`. */
const INVALIDAR = [['configuracoes-rateio'], ['rateios']];

/** Sequencia vigente, por ordem (GET /configuracoes-rateio). */
export function useConfiguracoesRateio() {
  return useConsulta<ConfiguracaoRateioResponse[]>(['configuracoes-rateio'], '/configuracoes-rateio');
}

/** Uma configuracao (GET /configuracoes-rateio/:id). */
export function useConfiguracaoRateio(id: string | undefined) {
  return useConsulta<ConfiguracaoRateioResponse>(['configuracoes-rateio', id], `/configuracoes-rateio/${id}`, { ativo: !!id });
}

/** Centros de apoio sem configuracao e destinos validos para a ordem (GET /configuracoes-rateio/destinos). */
export function useDestinosConfiguracao(q: { centroId?: string; ordem?: number } = {}) {
  return useConsulta<DestinosConfiguracaoResponse>(['configuracoes-rateio', 'destinos'], '/configuracoes-rateio/destinos', { query: q });
}

export function useCriarConfiguracaoRateio() {
  return useMutacao<ConfiguracaoRateioResponse, CriarConfiguracaoRateioDto>({
    metodo: 'POST',
    caminho: () => '/configuracoes-rateio',
    corpo: (v) => v,
    invalidar: INVALIDAR,
  });
}

export function useAtualizarConfiguracaoRateio() {
  return useMutacao<ConfiguracaoRateioResponse, { id: string } & AtualizarConfiguracaoRateioDto>({
    metodo: 'PUT',
    caminho: (v) => `/configuracoes-rateio/${v.id}`,
    corpo: ({ id: _id, ...resto }) => resto,
    invalidar: INVALIDAR,
  });
}

/** Encerramento (DELETE /configuracoes-rateio/:id): 204. */
export function useEncerrarConfiguracaoRateio() {
  return useMutacao<void, string>({
    metodo: 'DELETE',
    caminho: (id) => `/configuracoes-rateio/${id}`,
    invalidar: INVALIDAR,
  });
}

/** Nova ordem (POST /configuracoes-rateio/reordenar) com a lista de ids na sequencia desejada. */
export function useReordenarConfiguracoes() {
  return useMutacao<ConfiguracaoRateioResponse[], ReordenarConfiguracoesDto>({
    metodo: 'POST',
    caminho: () => '/configuracoes-rateio/reordenar',
    corpo: (v) => v,
    invalidar: INVALIDAR,
  });
}
